import { EditRideDialogContext } from "components/events/judging/useEditRideDialogContext/useEditRideDialogContext";
import { useRef } from "react";

type Callback = () => void;
type ListenerMap = Record< string, Callback>;

export const EditRideDialogProvider: React.FCWithChildren = ({ children }) => {
    const listenersMap = useRef<ListenerMap>({});

    const registerOpenDialogCallback = (rideIndex: number, athleteId: string, callback: Callback) => {
        listenersMap.current[`${rideIndex}-${athleteId}`] = callback;
    };
    
    const triggerOpenDialog = (rideIndex: number, athleteId: string) => {
        listenersMap.current[`${rideIndex}-${athleteId}`]?.();
    };

    return (
        <EditRideDialogContext.Provider value={{ registerOpenDialogCallback, triggerOpenDialog }}>
            {children}
        </EditRideDialogContext.Provider>
    );
};
